// import React from "react";
// import { Modal, ModalProps } from "antd";

// interface ReusableModalProps extends ModalProps {
//   place?: string;
//   open: boolean;
// }

// const ModalBase: React.FC<ReusableModalProps> = (props: ReusableModalProps) => {
//   const { place, open, children } = props;

//   if (place === "center") {
//     return (
//       <>
//         {open && (
//           <Modal
//             {...props}
//             open={open}
//             className={`modal_fixed_right ${props.className}`}
//             centered={false}
//             transitionName="slide-in"
//             maskTransitionName="fade"
//             maskClosable={false}
//           >
//             {children}
//           </Modal>
//         )}
//       </>
//     );
//   }
//   return (
//     <>
//       {open && (
//         <Modal
//           {...props}
//           open={open}
//           className={`modal_center ${props.className}`}
//         >
//           {children}
//         </Modal>
//       )}
//     </>
//   );
// };

// export default ModalBase;

import React from "react";
import { Modal, ModalProps } from "antd";

interface ReusableModalProps extends ModalProps {
  place?: string;
  open: boolean;
}

const ModalBase: React.FC<ReusableModalProps> = (props: ReusableModalProps) => {
  const { place, open, children, className, ...restProps } = props;

  if (!open) return null;

  const modalProps = {
    ...restProps,
    open,
    className: `${place === "right" ? "modal_fixed_right" : "modal_center"} ${className || ""}`,
    children,
  };

  if (place === "right") {
    return (
      <Modal
        {...modalProps}
        centered={false}
        width={props.width}
        transitionName="slide-in"
        maskTransitionName="fade"
        maskClosable={false}
      />
    );
  }

  return <Modal {...modalProps} width={props.width} />;
};

export default ModalBase;
